
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download-from-instagram/[id]",
      function () {
        return require("private-next-pages/download-from-instagram/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/download-from-instagram/[id]"])
      });
    }
  